import React, { useEffect, useState } from 'react';
import DataSyncExecutionList from './components/DataSyncExecutionList';
import { useHistory, useParams } from 'react-router-dom';
import DataSyncDetailsStore from '../../stores/DataSyncDetailsStore';
import { showToasts } from '../../lib/toaster';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { useObserver } from 'mobx-react-lite';
import { Button, Intent } from '@blueprintjs/core';
import MainContainer from './MainContainer';

export const DataSyncExecutionsPage = () => {
  const {dataSyncId} = useParams<{ dataSyncId: string }>();
  const [dataSyncDetailsStore, setDataSyncDetailsStore] = useState<DataSyncDetailsStore | null>(null);
  const history = useHistory();

  const refreshExecutions = async (store: DataSyncDetailsStore) => {
    try {
      return await store.getExecutions();
    } catch (e) {
      showToasts([{intent: 'danger', message: `Failed to fetch data sync executions. ${e}`}]);
    }
  };

  useEffect(() => {
    const store = new DataSyncDetailsStore(dataSyncId);
    setDataSyncDetailsStore(store);
    refreshExecutions(store);
  }, [dataSyncId]);

  return useObserver(() => {
    const isReady = dataSyncDetailsStore !== null;

    const headerActions = (
      <>
        <Button
          text="Refresh"
          intent={Intent.NONE}
          onClick={async () => {
            if (dataSyncDetailsStore) {
              await refreshExecutions(dataSyncDetailsStore);
            }
          }}
        />
        <Button
          text="Close"
          intent={Intent.PRIMARY}
          onClick={() => {
            history.push('/data_syncs');
          }}
        />
      </>
    );

    return (
      <MainContainer title="Executions List" headerActions={headerActions} fixedHeight={true}>
        {isReady ? <DataSyncExecutionList detailStore={dataSyncDetailsStore}/> : <LoadingIndicator/>}
      </MainContainer>
    );
  });
};
